export const MODULE_NAME = 'wellbeingFeed';

export const INITIAL_STATE = {
  isFetchingWellbeingFeed: false,
  wellbeingFeed: [],
};
